import Modal from '@/shared/components/UI/Modal';
import Button from '@/shared/components/UI/Button';

interface TermsOfServiceModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const TermsOfServiceModal: React.FC<TermsOfServiceModalProps> = ({
  isOpen,
  onClose,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="sm">
      <div className="text-left">
        <h2 className="mb-4 text-lg font-bold text-[#1D1D1D]">
          서비스 이용약관
        </h2>

        <div className="max-h-[50vh] overflow-y-auto pr-2">
          <div className="text-xs text-[#1D1D1D]">
            <p>
              본 웹사이트는 K-MONSTAR가 운영합니다. 사이트 전반에 걸쳐
              -K-MONSTAR-, -당사-, -저희- 그리고 -우리-라는 용어는 K-MONSTAR를
              지칭합니다. K-MONSTAR는 본 사이트의 모든 정보, 도구 및 서비스를
              여기에 명시된 모든 약관, 조건, 정책 및 공지사항에 동의하는
              조건으로 사용자인 귀하에게 제공합니다.
            </p>

            <p>
              당사의 사이트를 방문하거나 제품을 구매함으로써, 귀하는 당사의
              -서비스-에 참여하게 되며 여기에 명시된 약관(-서비스 이용약관-,
              -약관-)과 하이퍼링크로 제공되는 추가 약관 및 정책에 구속됨에
              동의합니다. 본 서비스 이용약관은 브라우저, 벤더, 고객, 판매자
              및/또는 콘텐츠 제공자를 포함하되 이에 국한되지 않는 사이트의 모든
              사용자에게 적용됩니다.
            </p>

            <p>
              본 웹사이트를 이용하거나 접속하기 전에 이 서비스 이용약관을 주의
              깊게 읽어주시기 바랍니다. 사이트의 어떤 부분에 접속하거나
              이용함으로써, 귀하는 이 서비스 이용약관에 구속됨에 동의합니다. 본
              계약의 모든 약관에 동의하지 않는 경우, 웹사이트에 접속하거나
              서비스를 이용할 수 없습니다. 본 서비스 이용약관이 제안으로
              간주되는 경우, 수락은 명시적으로 본 서비스 이용약관으로
              제한됩니다.
            </p>

            <p>
              현재 스토어에 추가되는 모든 새로운 기능이나 도구에도 서비스
              이용약관이 적용됩니다. 이 페이지에서 언제든지 최신 버전의 서비스
              이용약관을 검토할 수 있습니다. 당사는 웹사이트에 업데이트 및/또는
              변경사항을 게시함으로써 서비스 이용약관의 일부를 업데이트, 변경
              또는 교체할 권리를 보유합니다. 변경사항을 주기적으로 확인하는 것은
              귀하의 책임입니다. 변경사항 게시 후 지속적인 웹사이트 사용 또는
              접속은 해당 변경사항에 대한 수락을 구성합니다.
            </p>

            <p>
              당사의 스토어는 Shopify Inc.에서 호스팅됩니다. 그들은 당사가
              제품과 서비스를 판매할 수 있게 해주는 온라인 전자상거래 플랫폼을
              제공합니다.
            </p>

            <h2>제1조 - 온라인 스토어 약관</h2>
            <p>
              본 서비스 이용약관에 동의함으로써, 귀하는 귀하가 거주하는 주 또는
              지방의 성년 연령 이상임을 표명하거나, 귀하가 성년 연령 이상이며
              귀하의 부양 미성년자가 본 사이트를 사용하는 것을 동의했음을
              표명합니다.
            </p>
            <p>
              당사의 제품을 불법적이거나 무단 목적으로 사용할 수 없으며, 서비스
              사용 시 관할 지역의 법률(저작권법을 포함하되 이에 국한되지 않음)을
              위반할 수 없습니다.
            </p>
            <p>
              웜이나 바이러스 또는 파괴적 성격의 코드를 전송해서는 안 됩니다.
            </p>
            <p>약관의 위반 시 즉시 서비스가 종료됩니다.</p>

            <h2>제2조 - 일반 조건</h2>
            <p>
              당사는 언제든지 어떤 이유로든 누구에게나 서비스를 거부할 권리를
              보유합니다.
            </p>
            <p>
              귀하의 콘텐츠(신용카드 정보 제외)는 암호화되지 않은 상태로 전송될
              수 있으며 (a) 다양한 네트워크를 통한 전송 및 (b) 연결 네트워크나
              장치의 기술적 요구사항에 맞추기 위한 변경이 포함될 수 있음을
              이해합니다. 신용카드 정보는 네트워크 전송 중 항상 암호화됩니다.
            </p>
            <p>
              당사의 명시적 서면 허가 없이 서비스의 어떤 부분, 서비스 사용, 또는
              서비스가 제공되는 웹사이트의 연락처에 대한 접근을 복제, 복사,
              판매, 재판매 또는 악용하지 않을 것에 동의합니다.
            </p>
            <p>
              본 계약에 사용된 제목은 편의상 포함된 것이며 이 약관을 제한하거나
              영향을 미치지 않습니다.
            </p>

            <h2>제3조 - 정보의 정확성, 완전성 및 적시성</h2>
            <p>
              본 사이트에서 제공되는 정보가 정확하지 않거나, 완전하지 않거나,
              현재의 것이 아닌 경우 당사는 책임을 지지 않습니다. 본 사이트의
              자료는 일반적인 정보 제공만을 목적으로 하며, 더 정확하고 완전하며
              시의적절한 정보를 제공하는 일차적 정보원과 상담 없이 의사결정의
              유일한 근거로 사용되어서는 안 됩니다. 본 사이트의 자료에 대한
              신뢰는 귀하의 책임입니다.
            </p>
            <p>
              본 사이트는 특정 역사적 정보를 포함할 수 있습니다. 역사적 정보는
              필연적으로 현재의 것이 아니며 참고용으로만 제공됩니다. 당사는 본
              사이트의 내용을 언제든지 수정할 권리를 보유하지만, 사이트의 정보를
              업데이트할 의무는 없습니다. 귀하는 사이트의 변경사항을
              모니터링하는 것이 귀하의 책임임에 동의합니다.
            </p>

            <h2>제4조 - 서비스 및 가격의 수정</h2>
            <p>당사 제품의 가격은 사전 통지 없이 변경될 수 있습니다.</p>
            <p>
              당사는 언제든지 사전 통지 없이 서비스(또는 그 일부나 내용)를
              수정하거나 중단할 권리를 보유합니다.
            </p>
            <p>
              서비스의 수정, 가격 변경, 중단 또는 중지에 대해 당사는 귀하나
              제3자에게 책임을 지지 않습니다.
            </p>

            <h2>제5조 - 제품 또는 서비스</h2>
            <p>
              특정 제품이나 서비스는 웹사이트를 통해서만 독점적으로 제공될 수
              있습니다. 이러한 제품이나 서비스는 수량이 제한될 수 있으며 당사의
              반품 정책에 따라서만 반품 또는 교환이 가능합니다.
            </p>
            <p>
              당사는 스토어에 표시되는 제품의 색상과 이미지를 가능한 한 정확하게
              표시하기 위해 모든 노력을 기울였습니다. 귀하의 컴퓨터 모니터에
              표시되는 색상이 정확할 것이라고 보장할 수 없습니다.
            </p>
            <p>
              당사는 제품이나 서비스의 판매를 특정 개인, 지리적 지역 또는
              관할권으로 제한할 권리를 보유하지만 의무는 없습니다. 당사는 이
              권리를 케이스별로 행사할 수 있습니다. 당사는 제공하는 제품이나
              서비스의 수량을 제한할 권리를 보유합니다. 모든 제품 설명이나 제품
              가격은 당사의 단독 재량으로 사전 통지 없이 언제든지 변경될 수
              있습니다. 당사는 언제든지 제품을 중단할 권리를 보유합니다. 본
              사이트에서 제공되는 제품이나 서비스에 대한 제안은 법으로 금지된
              곳에서는 무효입니다.
            </p>
            <p>
              당사는 귀하가 구매하거나 획득한 제품, 서비스, 정보 또는 기타
              자료의 품질이 귀하의 기대를 충족시킬 것이라거나 서비스의 오류가
              수정될 것이라고 보장하지 않습니다.
            </p>

            <h2>제6조 - 청구 및 계정 정보의 정확성</h2>
            <p>
              당사는 귀하가 당사에 제출한 모든 주문을 거부할 권리를 보유합니다.
              당사는 단독 재량으로 1인당, 가구당 또는 주문당 구매 수량을
              제한하거나 취소할 수 있습니다. 이러한 제한에는 동일 고객 계정,
              동일 신용카드로 주문하거나 동일한 청구 및/또는 배송 주소를
              사용하는 주문이 포함될 수 있습니다. 주문을 변경하거나 취소하는
              경우, 주문 시 제공된 이메일 및/또는 청구 주소/전화번호로 연락하여
              알릴 수 있습니다. 당사는 딜러, 재판매업자 또는 유통업자가 주문한
              것으로 보이는 주문을 제한하거나 금지할 권리를 보유합니다.
            </p>
            <p>
              귀하는 당사 스토어에서 이루어진 모든 구매에 대해 현재의, 완전하고
              정확한 구매 및 계정 정보를 제공하는 것에 동의합니다. 귀하는 거래를
              완료하고 필요한 경우 연락할 수 있도록 이메일 주소, 신용카드 번호
              및 만료일을 포함한 계정 및 기타 정보를 즉시 업데이트하는 것에
              동의합니다.
            </p>
            <p>자세한 내용은 당사의 반품 정책을 검토하시기 바랍니다.</p>

            <h2>제7조 - 선택적 도구</h2>
            <p>
              당사는 당사가 모니터링하거나 통제하거나 입력하지 않는 제3자 도구에
              대한 접근을 제공할 수 있습니다.
            </p>
            <p>
              귀하는 당사가 그러한 도구에 대한 접근을 -있는 그대로- 그리고 -이용
              가능한 대로- 어떠한 보증, 진술 또는 조건 없이 그리고 어떠한 보증
              없이 제공한다는 것을 인정하고 동의합니다. 당사는 선택적 제3자
              도구의 사용으로 인해 발생하거나 관련된 어떠한 책임도 지지
              않습니다.
            </p>
            <p>
              사이트를 통해 제공되는 선택적 도구의 사용은 전적으로 귀하의 위험과
              재량에 따르며, 귀하는 관련 제3자 제공자가 제공하는 조건에
              익숙해지고 승인해야 합니다.
            </p>
            <p>
              당사는 또한 향후 웹사이트를 통해 새로운 서비스 및/또는 기능(새로운
              도구 및 자원 출시 포함)을 제공할 수 있습니다. 이러한 새로운 기능
              및/또는 서비스도 본 서비스 이용약관의 적용을 받습니다.
            </p>

            <h2>SECTION 8 - 제3자 링크</h2>
            <p>
              서비스를 통해 제공되는 일부 콘텐츠, 제품 및 서비스에는 제3자의
              자료가 포함될 수 있습니다.
            </p>
            <p>
              이 사이트의 제3자 링크는 당사와 제휴되지 않은 제3자 웹사이트로
              연결될 수 있습니다. 당사는 해당 콘텐츠나 정확성을 검토하거나
              평가할 책임이 없으며, 어떠한 제3자 자료, 웹사이트, 제품 또는
              서비스에 대해서도 책임이나 의무를 지지 않습니다.
            </p>
            <p>
              제3자 웹사이트와 관련된 상품, 서비스, 리소스, 콘텐츠 또는 기타
              거래로 인해 발생하는 손해나 피해에 대해 당사는 책임을 지지
              않습니다. 거래 전에 제3자의 정책과 관행을 주의 깊게 검토하고
              이해하시기 바랍니다. 제3자 제품에 대한 불만, 청구, 우려 또는
              질문은 해당 제3자에게 직접 문의하시기 바랍니다.
            </p>

            <h2>SECTION 9 - 사용자 의견, 피드백 및 기타 제출물</h2>
            <p>
              당사의 요청에 따라 특정 제출물(예: 콘테스트 응모작)을 보내거나,
              당사의 요청 없이 창의적인 아이디어, 제안, 계획 등을 온라인,
              이메일, 우편 등을 통해 제출하는 경우(이하 -의견-) 해당 의견에 대한
              제한 없는 사용권을 당사에 부여하게 됩니다. 당사는 이를 편집, 복사,
              출판, 배포, 번역 및 기타 방식으로 사용할 권리를 가집니다.
            </p>
            <p>
              당사는 다음과 같은 의무를 지지 않습니다: (1) 제출된 의견을 비밀로
              유지할 의무; (2) 제출된 의견에 대한 보상 지급 의무; (3) 제출된
              의견에 대한 응답 의무.
            </p>
            <p>
              당사는 법적 권리 침해, 외설적, 모욕적이거나 부적절한 콘텐츠에 대해
              임의로 모니터링, 편집 또는 삭제할 수 있는 권리를 가집니다.
            </p>
            <p>
              사용자는 제출한 의견이 제3자의 권리를 침해하지 않으며,
              불법적이거나 악성 소프트웨어를 포함하지 않는다는 것에 동의합니다.
            </p>

            <h2>SECTION 10 - 개인 정보</h2>
            <p>
              스토어를 통해 제출된 개인 정보는 당사의 개인정보처리방침에 따라
              처리됩니다.
            </p>

            <h2>SECTION 11 - 오류, 부정확성 및 누락</h2>
            <p>
              사이트나 서비스에서 제품 설명, 가격, 프로모션, 배송 시간 등에 대한
              오류나 부정확성, 누락이 발생할 수 있습니다. 당사는 사전 통지 없이
              이러한 오류를 수정하거나 주문을 취소할 권리를 가집니다.
            </p>

            <h2>SECTION 12 - 금지된 사용</h2>
            <p>사용자는 다음과 같은 행위를 해서는 안 됩니다:</p>
            <ul>
              <li>불법적인 목적</li>
              <li>타인을 불법 행위로 유도</li>
              <li>지적 재산권 침해</li>
              <li>차별, 괴롭힘, 모욕, 명예 훼손</li>
              <li>악성 코드 업로드</li>
              <li>타인의 개인 정보 수집</li>
              <li>스팸, 피싱, 스크래핑</li>
              <li>음란하거나 부도덕한 목적</li>
              <li>보안 기능 방해</li>
            </ul>
            <p>
              이러한 금지된 사용을 위반하면 서비스 이용이 종료될 수 있습니다.
            </p>

            <h2>SECTION 13 - 보증의 면책; 책임의 제한</h2>
            <p>
              당사는 서비스 이용이 중단 없이, 정확하고, 신뢰할 수 있다는 것을
              보장하지 않습니다. 서비스 및 서비스 제공 제품은 -있는 그대로-
              제공되며, 명시적 또는 묵시적인 모든 보증이 제외됩니다.
            </p>
            <p>
              당사는 사용자가 서비스를 통해 얻은 정보의 정확성이나 손해에 대해
              어떠한 책임도 지지 않습니다.
            </p>

            <h2>SECTION 14 - 면책</h2>
            <p>
              사용자는 서비스 약관을 위반하거나 법률을 위반하여 발생하는 모든
              청구 및 요구로부터 당사를 면책하고 방어할 것에 동의합니다.
            </p>

            <h2>SECTION 15 - 분리 가능성</h2>
            <p>
              약관의 일부 조항이 무효화되더라도, 나머지 조항의 유효성에는 영향을
              미치지 않습니다.
            </p>

            <h2>SECTION 16 - 계약 해지</h2>
            <p>
              사용자 또는 당사는 언제든지 계약을 종료할 수 있으며, 종료 전에
              발생한 모든 의무는 계속 유효합니다.
            </p>

            <h2>SECTION 17 - 사용자 생성 콘텐츠</h2>
            <p>
              사용자가 데이터를 제출할 경우, 해당 데이터를 사용하는 비독점적이고
              로열티 없는 사용권을 당사에 부여합니다. 제출한 데이터는 공개될 수
              있으며, 사용자는 해당 데이터에 대한 모든 권한을 보유해야 합니다.
            </p>

            <h2>SECTION 18 - 세금</h2>
            <p>
              제품의 총 가격에는 배송 주소 기준으로 적용되는 판매세가
              포함됩니다.
            </p>

            <h2>SECTION 19 - 전체 계약</h2>
            <p>
              이 약관은 사용자와 당사 간의 전체 계약을 구성하며, 이전의 모든
              계약과 합의에 우선합니다.
            </p>

            <h2>SECTION 20 - 준거법</h2>
            <p>이 약관은 대한민국 법률에 따라 규율되고 해석됩니다.</p>

            <h2>SECTION 21 - 약관 변경</h2>
            <p>
              당사는 언제든지 약관을 수정할 권리가 있으며, 사용자는 변경 사항을
              주기적으로 확인해야 합니다.
            </p>

            <h2>SECTION 22 - 연락처 정보</h2>
            <p>
              이용 약관에 대한 질문은 help@kmonstar.com 으로 문의해 주시기
              바랍니다.
            </p>
          </div>
        </div>

        <div className="mt-6">
          <Button
            type="button"
            variant="primary"
            size="xs"
            onClick={onClose}
            fullWidth
          >
            Verify
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default TermsOfServiceModal;
